export interface UrlValidationResult {
  isValid: boolean;
  error?: string;
  isMainPage?: boolean;
}

export class UrlValidator {
  /**
   * Basis-URL-Validierung (für alle URLs)
   * Prüft nur, ob es eine gültige URL-Syntax ist
   */
  static validateUrl(url: string): UrlValidationResult {
    try {
      new URL(url);
      return { isValid: true };
    } catch {
      return {
        isValid: false,
        error: 'Bitte gib eine gültige URL ein'
      };
    }
  }

  /**
   * Erweiterte Validierung für Artikel-URLs (keine Hauptseiten)
   * Prüft zusätzlich, ob die URL auf einen Artikel statt nur auf die Hauptseite verweist.
   */
  static validateArticleUrl(url: string): UrlValidationResult {
    const basicValidation = this.validateUrl(url);
    if (!basicValidation.isValid) {
      return basicValidation;
    }

    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;

      // Hauptseite erkannt
      if (pathname === '/' || pathname === '') {
        return {
          isValid: false,
          error: 'Bitte gib die URL zu einem spezifischen Artikel ein, nicht nur die Hauptseite der Plattform.',
          isMainPage: true
        };
      }

      return { isValid: true };
    } catch {
      return {
        isValid: false,
        error: 'Bitte gib eine gültige URL ein'
      };
    }
  }

  /**
   * Spezielle Validierung für Bildquelle-URLs
   * Verwendet für ArticleWizardPage - Bildquelle-URLs
   */
  static validateImageSourceUrl(url: string): UrlValidationResult {
    const basicValidation = this.validateUrl(url);
    if (!basicValidation.isValid) {
      return {
        isValid: false,
        error: 'Bitte gib eine gültige https:// URL für die Bildquelle ein'
      };
    }
    if (!url.startsWith('https://')) {
      return {
        isValid: false,
        error: 'Die Bildquelle-URL muss mit https:// beginnen'
      };
    }
    return { isValid: true };
  }
}
